// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import "firebase/storage";
import { getStorage } from "firebase/storage";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";

// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCncE7lg9UEt4AM_vzqfLjv6wvrkHGYL5g",
  authDomain: "eight-8-ug.firebaseapp.com",
  projectId: "eight-8-ug",
  storageBucket: "eight-8-ug.appspot.com",
  messagingSenderId: "1028050993998",
  appId: "1:1028050993998:web:a3b3579216f44975a9541f",
  measurementId: "G-L8P92FPNSD",
};

const app = initializeApp(firebaseConfig);

// Initialize Firebase
// const analytics = getAnalytics(app);
// Create a root reference
const storage = getStorage();
const db = getFirestore();
const functions = getFunctions();
const httpsCall = httpsCallable;
const auth = getAuth(app);
// run on emulator
// connectFunctionsEmulator(functions, "localhost", "5001");

export { auth, storage, functions, httpsCall, db };
